import './Style/Header.css'
export default function Header(){
    return(
        <>
        <div id="Header">
            <h1>Welcome to NAMAMI Restaurant !!</h1>
        </div>
        </>
    )
}